import Vue from '@/index.js'
import page from '@/mixins/page'

// Подключение стилей только для этой страницы
require('./page.scss')

export default new Vue({
  mixins: [page],
  el: '#app',
  data(){
    return {
      password: false // for user page
    }
  }
})
